// invoiceGenerator.js
// Generates PDF invoices using jsPDF

import jsPDF from 'jspdf';

export const generateInvoice = async (invoiceData) => {
  const {
    invoiceNumber,
    date,
    clientName,
    clientEmail,
    petName,
    serviceName,
    amount,
    paymentMethod,
    businessName,
    businessEmail,
    businessPhone,
    businessAddress,
    logoUrl
  } = invoiceData;

  // Create PDF
  const doc = new jsPDF();
  
  const pageWidth = doc.internal.pageSize.width;
  let yPos = 20;

  // Add logo if available
  if (logoUrl) {
    try {
      // You would add logo here - for now skip
      // doc.addImage(logoUrl, 'PNG', 15, yPos, 40, 40);
      yPos += 15;
    } catch (error) {
      console.log('Logo not added');
    }
  }

  // Business header
  doc.setFontSize(24);
  doc.setFont(undefined, 'bold');
  doc.text(businessName || 'Pet Grooming Salon', 15, yPos);
  
  yPos += 10;
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  if (businessEmail) doc.text(businessEmail, 15, yPos);
  yPos += 5;
  if (businessPhone) doc.text(businessPhone, 15, yPos);
  yPos += 5;
  if (businessAddress) doc.text(businessAddress, 15, yPos);

  // Invoice title and number (right aligned)
  doc.setFontSize(28);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(147, 51, 234); // Purple
  doc.text('INVOICE', pageWidth - 15, 30, { align: 'right' });
  
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.setFont(undefined, 'normal');
  doc.text(invoiceNumber, pageWidth - 15, 40, { align: 'right' });
  doc.text(new Date(date).toLocaleDateString('en-GB'), pageWidth - 15, 47, { align: 'right' });

  // Horizontal line
  yPos = 60;
  doc.setDrawColor(200, 200, 200);
  doc.line(15, yPos, pageWidth - 15, yPos);

  // Bill To section
  yPos += 10;
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('BILL TO:', 15, yPos);
  
  yPos += 7;
  doc.setFont(undefined, 'normal');
  doc.text(clientName, 15, yPos);
  yPos += 6;
  doc.text(clientEmail, 15, yPos);
  if (petName) {
    yPos += 6;
    doc.text(`Pet: ${petName}`, 15, yPos);
  }

  // Service details table
  yPos += 20;
  
  // Table header
  doc.setFillColor(147, 51, 234); // Purple
  doc.rect(15, yPos, pageWidth - 30, 10, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFont(undefined, 'bold');
  doc.text('Service', 20, yPos + 7);
  doc.text('Amount', pageWidth - 20, yPos + 7, { align: 'right' });

  // Table content
  yPos += 10;
  doc.setTextColor(0, 0, 0);
  doc.setFont(undefined, 'normal');
  
  // Service row
  doc.text(serviceName, 20, yPos + 7);
  doc.text(`£${amount.toFixed(2)}`, pageWidth - 20, yPos + 7, { align: 'right' });
  
  doc.setDrawColor(220, 220, 220);
  doc.line(15, yPos + 10, pageWidth - 15, yPos + 10);

  // Total
  yPos += 20;
  doc.setFont(undefined, 'bold');
  doc.setFontSize(14);
  doc.text('TOTAL:', pageWidth - 80, yPos);
  doc.text(`£${amount.toFixed(2)}`, pageWidth - 20, yPos, { align: 'right' });

  // Payment method
  yPos += 15;
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(`Payment Method: ${paymentMethod.toUpperCase()}`, 15, yPos);
  doc.setTextColor(34, 197, 94); // Green
  doc.text('PAID', pageWidth - 20, yPos, { align: 'right' });
  doc.setTextColor(0, 0, 0);

  // Footer
  yPos = doc.internal.pageSize.height - 30;
  doc.setDrawColor(200, 200, 200);
  doc.line(15, yPos, pageWidth - 15, yPos);
  
  yPos += 10;
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.text('Thank you for your business!', pageWidth / 2, yPos, { align: 'center' });

  // Return PDF as blob
  return doc.output('blob');
};

export const generateInvoiceFilename = (invoiceNumber) => {
  return `${invoiceNumber}.pdf`;
};